"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toRelatedArticlesSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toRelatedArticlesSlice = function (data, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, slice_1.toAnchoredSlice(data, types_1.SliceType.RelatedArticles)), { title: logger.required(fields_1.toText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.title)), articles: data.items
            .map(function (item) { return fields_1.toDocumentLink(item.article, logger); })
            .filter(Boolean) }));
};
exports.toRelatedArticlesSlice = toRelatedArticlesSlice;
//# sourceMappingURL=related-articles-slice.js.map